import { render } from "./prodStatistics.vue?vue&type=template&id=1a5a3a3f"
import script from "./prodStatistics.vue?vue&type=script&lang=js"
export * from "./prodStatistics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__